import React from "react";

import { Status, Protocol } from "./lib/constants";
import { MessageFactory } from "./lib/messages";
import GameUtils from "./lib/gameutils";
import { MessagesList } from "./lib/hilo_msg";
import { WS } from "./lib/websocket";

import Hilo from "./components/Hilo";
import NoSignal from "./components/otherPages/noSignal/NoSignal";
import Notification from "./components/otherPages/notifications/Notification";
import { logger } from './components/helpers/logger'

import { AppContainer } from "./AppStyled";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.WS_URL = "{{SERVER_WS_URL}}";
    this.hostname = window.location.hostname
    if (this.hostname === 'localhost') {
      this.WS_URL = 'wss://dev.orbitalgaming.io/websocketbridge/ws/hi-lo'
    } else if (this.WS_URL.includes('SERVER_WS_URL')) {
      this.WS_URL = `wss://${this.hostname}/websocketbridge/ws/hi-lo`
    }

    this.state = {
      user_id: null,
      balance: null,
      bet: null,
      userInfo: {
        minBet: null,
        maxBet: null,
        curr: null,
        precision: null,
      },
      picks: [],
      cardCoefHistory: [1],
      current: null,
      noSignal: false,
      errorMsg: {
        mainText: "",
        btnText: "",
        reload: false,
      },
      betReply: null,
      pageNotFound: null,
      notification: false,
      notificationfadeOut: false,
      cardHistory: [],
      gameIsOn: false,
      inactiveGame: false,
      cashout: false,
      result: false,
      above: false,
      isDisabled: true,
      winSound: false,
      currentAction: "",
      cardChange: false,
      myHistory: [],
      allHistory: [],
      highRoller: [],
      stateRound: {
        currentCoef: null,
        hiCoef: null,
        loCoef: null,
        currentCard: null,
        won: null,
        state: null,
      },
      provablyFairSeeds: {
        client_seed: "",
        server_seed_SHA256: "",
        nonce: 0,
        old_client_seed: "",
        old_server_seed: "",
        old_server_seed_SHA256: "",
        old_nonce: 0,
        next_server_seed_SHA256: "",
      },
      userSettings: {
        music: "0",
        sound: "0",
        volume: "0",
      },
      volumeLocal: "0",
      rotateBtnDisable: false,
      gameStates: "",
    };
    this.historyLocal = [];
    this.myHistoryLocal = [];
    this.highRollerLocal = [];
    this.Globals = {};
    this.myTimeout = null;
    this.notificationTimeOut = null;
    this.actions = {
      NONE: "NONE",
      CHANGE: "CHANGE",
      HI: "HI",
      LO: "LO",
    };
  }
  componentDidMount() {
    window._mfq = window._mfq || [];
    (function () {
      var mf = document.createElement("script");
      mf.type = "text/javascript";
      mf.defer = true;
      mf.src =
        "https://cdn.mouseflow.com/projects/27d3415e-736e-4ff5-9a5c-1aa7729b351d.js";
      document.getElementsByTagName("head")[0].appendChild(mf);
    })();
    MessageFactory.messagesList = MessagesList;
    this.Globals.WS = new WS().Init(this).Start();
    
    console.log(
      "%cV.2.0.2 DG",
      "color: pink; background: black; padding: 5px; border-radius: 8px;"
    )
  }

  componentWillUnmount() {
    this.Globals.WS.Disconnect();
    this.setState({ myHistory: [], allHistory: [], highRoller: [] });
  }
  setStatus(status) {
    logger.log("%cstatus = ", "color:brown", status);
    switch (status) {
      case Status.CONNECTED:
        logger.log("%cconnected ", "color:green");
        this.setState({ noSignal: false, reload: false });

        var session = GameUtils.getParameterByName("session");
        if (typeof session == "string") {
          var loginMsg = MessageFactory.createMessage(
            Protocol.LOGIN,
            GameUtils.getParameterByName("session") + "@1"
          );
          this.Globals.WS.sendMessage(loginMsg);
        } else {
          logger.log("not logged in" + status);
        }
        break;

      case Status.DISCONNECTED:
        logger.log("%cdisconnected ", "color:brown");
        this.setState({
          noSignal: true,
          notification: false,
          above: false,
          errorMsg: {
            mainText:
              "Your session has expired, please reload the page to continue",
            reload: true,
            btnText: false,
          },
        });
        clearTimeout(this.myTimeout);

        break;

      default:
        break;
    }
  }
  doMessage = function (msg) {
    var msgObject = null;
    try {
      msgObject = MessageFactory.parseMessage(msg);
    } catch (e) {
      console.dir(e);
    }
    if (msgObject === null) {
      logger.log("doMessage msgObject === null ", msg);
      return;
    }
    switch (msgObject.type) {
      case Protocol.GAME_STATE:
        document.title = `HI-LO`;
        this.setState({
          balance: msgObject.balance,
          user_id: msgObject.user_id,

          userInfo: {
            minBet: msgObject.minBet,
            maxBet: msgObject.maxBet,
            curr: msgObject.currency,
            maxWin: msgObject.maxwin,
            precision: msgObject.precision,
          },
          provablyFairSeeds: {
            server_seed_SHA256: msgObject.server_seed_SHA256,
            client_seed: msgObject.client_seed,
            nonce: msgObject.nonce,
            next_server_seed_SHA256: msgObject.next_server_seed_SHA256,
          },
        });
        logger.log("%cGAME_STATE", "color:aqua", msgObject);
        break;
      case Protocol.USER_SETTINGS_RESPONCE:
        let min = this.state.userInfo.minBet;
        if (msgObject.settings.split(";").length !== 4) {
          msgObject.settings = `1;1;0.5;${min}`;
          const settings = MessageFactory.createMessage(
            Protocol.USER_SETTINGS,
            msgObject.settings
          );
          this.Globals.WS.sendMessage(settings);
        }
        // bet update
        let arr = msgObject.settings.split(";");
        if (arr[3] < min) {
          this.setState({
            bet: min,
          });
        } else {
          this.setState({
            bet: arr[3],
          });
        }
        this.setState({
          userSettings: {
            music: arr[0],
            sound: arr[1],
            volume: arr[2] <= 1 ? arr[2] : arr[2] / 100,
          },
          volumeLocal: arr[2],
        });

        break;
      case Protocol.STATE_ROUND:
        logger.log("%cSTATE_ROUND", "color:aqua", msgObject);
        const setState = this.setState.bind(this);
        this.setState({
          balance: msgObject.balance,
          picks: msgObject.userActions.map((e) => e.action),
          stateRound: {
            currentCoef: msgObject.currentCoef,
            hiCoef: msgObject.hiCoef,
            loCoef: msgObject.loCoef,
            currentCard: msgObject.currentCard,
            won: msgObject.won,
            state: msgObject.state,
          },
          current: msgObject.currentCard,
          isDisabled: false,
          winSound: false,
        });
        if (msgObject.state === 0) {
          this.setState({
            picks: [],
            isDisabled: false,
            result: false,
            cashout: false,
            gameIsOn: false,
            rotateBtnDisable: false,
            currentAction: "",
            gameStates: "init",
            cardChange: false,
          });
        }
        if (msgObject.state === 1) {
          this.setState({
            gameIsOn: true,
            cashout: false,
            gameStates: "started",
            cardChange: false,
          });
          if (
            this.state.currentAction === "HI" ||
            this.state.currentAction === "LO"
          ) {
            this.setState({ winSound: true });
          } else {
            this.setState({ winSound: false });
          }
          if (
            msgObject.userActions
              .map((e) => e.action.includes("HI"))
              .includes(true) ||
            msgObject.userActions
              .map((e) => e.action.includes("LO"))
              .includes(true) ||
            msgObject.userActions
              .map((e) => e.action.includes("SAME"))
              .includes(true)
          ) {
            this.setState({
              cashout: true,
            });
            this.myTimeout = setTimeout(function () {
              setState({ winSound: false });
            }, 300);
          }
        }
        if (msgObject.state === 2) {
          this.setState({
            gameIsOn: false,
            rotateBtnDisable: false,
            result: true,
            isDisabled: true,
            currentAction: "",
            gameStates: "end",
            cardChange: false,
          });

          this.myTimeout = setTimeout(function () {
            setState({
              picks: [],
              cashout: false,
            });
          }, 167);
          this.myTimeout = setTimeout(function () {
            setState({
              result: false,
              isDisabled: false,
              gameStates: "init",
            });
          }, 1500);
        }
        if (msgObject.state === 3) {
          this.setState({
            gameIsOn: false,
            rotateBtnDisable: false,
            picks: [],
            cashout: false,
            result: true,
            isDisabled: true,
            currentAction: "",
            gameStates: "end",
            // cardChange: false,
          });
          this.myTimeout = setTimeout(function () {
            setState({
              result: false,
              isDisabled: false,
              gameStates: "init",
            });
          }, 1500);
        }

        if (this.state.gameIsOn) {
          this.setState({
            cardHistory: msgObject.userActions.map((e) => e),
          });
          let changeCount = msgObject.userActions
            .map((e) => e.action)
            .filter(function (value) {
              return value === "CHANGE";
            }).length;
          if (changeCount === 51) {
            this.handleNotification("Only 1 skip left");
            this.setState({ rotateBtnDisable: false });
          } else if (changeCount > 51) {
            this.setState({ rotateBtnDisable: true });
          } else {
            this.setState({ rotateBtnDisable: false });
          }
        }
        break;
      case Protocol.GET_SEEDS_RESPONCE:
        this.setState({ provablyFairSeeds: msgObject });
        logger.log("%cGET_SEEDS_RESPONCE", "color:aqua", msgObject);
        break;
      case Protocol.GET_ROUND_RESPONCE:
        logger.log("%cGET_ROUND_RESPONCE", "color:aqua", msgObject);
        // setTimeout(() => {
        this.setState({ betReply: msgObject, pageNotFound: false });
        // }, 3000);
        break;
      case Protocol.HISTORY:
        this.historyLocal.unshift(msgObject);
        while (this.historyLocal.length > 18) {
          this.historyLocal.pop();
        }
        if (msgObject.user_id === this.state.user_id) {
          this.myHistoryLocal.unshift(msgObject);
          while (this.myHistoryLocal.length > 18) {
            this.myHistoryLocal.pop();
          }
        }
        if (msgObject.bigWin !== 0) {
          this.highRollerLocal.unshift(msgObject);
          while (this.highRollerLocal.length > 18) {
            this.highRollerLocal.pop();
          }
        }
        this.setState({
          allHistory: this.historyLocal,
          myHistory: this.myHistoryLocal,
          highRoller: this.highRollerLocal,
        });
        this.setState({
          ...this.state,
          myHistory: this.myHistoryLocal,
          allHistory: this.historyLocal,
          highRoller: this.highRollerLocal,
        });
        break;
      case Protocol.ERROR:
        console.error("doMessage error read " + msgObject.errorCode);
        if (this.state.isAutoOn) {
          this.toggleIsAutoOn(false);
        }
        switch (msgObject.errorCode) {
          case 1:
            console.error("CONCURRENT_CONNECTION");
            this.setState({
              noSignal: true,
              errorMsg: {
                mainText: "Another login has been detected",
                btnText: false,
                reload: true,
              },
            });
            break;
          case 2:
            console.error("INVALID_SESSION", msgObject);
            this.setState({
              noSignal: true,
              errorMsg: {
                mainText: "Something went wrong, please reload the page",
                errorBtn: false,
                reload: true,
              },
            });
            //start websocket or reload?
            break;
          case 3:
            console.error("INSUFFICIENT_FUNDS", msgObject);
            this.handleNotification("Not enough balance");
            this.setState({
              isDisabled: false,
              inactiveGame: true,
              gameStates: "init",
            });
            setTimeout(() => {
              this.setState({ inactiveGame: false });
            }, 167);
            break;
          case 4:
            console.error("INVALID_BET_AMOUNT", msgObject);
            this.handleNotification("Invalid stake amount");
            this.setState({
              isDisabled: false,
              inactiveGame: true,
              gameStates: "init",
            });
            setTimeout(() => {
              this.setState({ inactiveGame: false });
            }, 167);
            break;
          case 5:
            console.error("MONEY_TRANSFER_ERROR", msgObject);
            this.setState({
              noSignal: true,
              errorMsg: {
                mainText:
                  "Something went wrong, please reload the page",
                reload: true,
                btnText: false,
              },
            });
            break;
          case 6:
            console.error("INVALID_BET", msgObject);
            this.handleNotification("Invalid bet");
            this.setState({
              isDisabled: false,
              inactiveGame: true,
              gameStates: "init",
            });
            setTimeout(() => {
              this.setState({ inactiveGame: false });
            }, 167);
            break;
          case 7:
            console.error("PF_NOT_SET", msgObject);
            this.setState({
              noSignal: true,
              errorMsg: {
                mainText: "Error saving seeds, please try again later",
                reload: true,
                btnText: false,
              },
            });
            break;
          case 8:
            console.error("CLIENT_SEED_ERROR", msgObject);
            this.setState({
              noSignal: true,
              errorMsg: {
                mainText:
                  "Length of the seed must be minimum 16  and maximum 128 symbols",
                reload: true,
                btnText: false,
              },
            });
            break;
          case 9:
            console.error("CLIENT_SEED_OK", msgObject);
            this.handleNotification("Provably fair seed set successfully");
            this.setState({ isDisabled: false });
            break;
          case 10:
            console.error("SYSTEM_ERROR", msgObject);
            this.setState({
              noSignal: true,
              errorMsg: {
                mainText:
                  "Something went wrong, please reload the page",
                btnText: false,
                reload: true,
              },
            });
            break;
          case 11:
            console.error("INVALID_ACTION", msgObject);
            this.handleNotification("Invalid action");
            this.setState({ isDisabled: false, inactiveGame: true });
            setTimeout(() => {
              this.setState({ inactiveGame: false });
            }, 167);
            break;
          case 13:
            console.error("NOT_FOUND", msgObject);
            this.handleNotification("Bet info is not found");
            this.setState({ isDisabled: false, pageNotFound: true });
            break;
          case 14:
            console.error("GAME_NOT_ACTIVE", msgObject);
            this.setState({
              noSignal: true,
              errorMsg: {
                mainText: "Game is not active",
                reload: true,
                btnText: false,
              },
            });
            break;
          case 16:
            console.error("INSUFFICIENT_FUNDS", msgObject);
            this.handleNotification("Not enough balance");
            this.setState({
              isDisabled: false,
              inactiveGame: true,
              gameStates: "init",
            });
            setTimeout(() => {
              this.setState({ inactiveGame: false });
            }, 167);
            break;
          case 115:
            console.error("MAX_BET_LIMIT", msgObject);
            this.handleNotification("You have exceeded your betting limit");
            this.setState({ isDisabled: false, inactiveGame: true });
            setTimeout(() => {
              this.setState({ inactiveGame: false });
            }, 167);
            break;
          default:
            console.error("ERROR", msgObject);
            this.setState({
              noSignal: true,
              errorMsg: {
                mainText:
                  "Something went wrong, please reload the page",
                btnText: false,
                reload: true,
              },
            });
            break;
        }
        break;

      default:
        break;
    }
  };
  saveUserSettings = (userSettings) => {
    const { bet } = this.state;
    const sets = Object.values(userSettings);
    const str = sets.concat(bet);
    const j = str.join(";");
    const settings = MessageFactory.createMessage(Protocol.USER_SETTINGS, j);
    this.Globals.WS.sendMessage(settings);
  };
  saveBet = (b) => {
    const { userSettings } = this.state;
    const sets = Object.values(userSettings);
    const str = sets.concat(+b);
    const j = str.join(";");
    const settings = MessageFactory.createMessage(Protocol.USER_SETTINGS, j);
    this.Globals.WS.sendMessage(settings);
  };

  handleNoSignal = (e) => this.setState({ noSignal: e });

  handleCashout = (e) => this.setState({ cashout: e });

  handleBetAmount = (e) => this.setState({ bet: e });

  handleGameIsOn = (e) => this.setState({ gameIsOn: e });

  handleIsDisabled = (e) => this.setState({ isDisabled: e });

  handleCurrent = (e) => this.setState({ current: e });

  handleResult = (e) => this.setState({ result: e });

  handleAbove = (e) => {
    this.setState({ above: e });
  };
  handleNotification = (n) => {
    // if (!n) {
    //   this.setState({ notificationfadeOut: true });
    //   clearTimeout(this.notificationTimeOut);
    //   setTimeout(() => {
    //     this.setState({ notification: n, notificationfadeOut: false });
    //   }, 333);
    // }
    //
    if (!!n) {
      this.setState({ notification: n });
      clearTimeout(this.notificationTimeOut);
      this.notificationTimeOut = setTimeout(() => {
        this.setState({ notificationfadeOut: true });
        setTimeout(() => {
          this.setState({ notification: false, notificationfadeOut: false });
        }, 333);
      }, 1666);
    }
  };
  // GAMEPLAY

  handleStartRound = (bet) => {
    const { balance } = this.state;
    if (+balance >= +bet) {
      this.handleCashout(false);
      this.saveBet(bet);
      this.setState({ gameStates: "start" });
      setTimeout(() => {
        this.Globals.WS.sendMessage(
          MessageFactory.createMessage(Protocol.START_ROUND, parseFloat(bet))
        );
      }, 167);
      clearTimeout(this.myTimeout);
    } else {
      this.handleNotification("Not enough balance");
      this.setState({
        isDisabled: false,
        inactiveGame: true,
        gameStates: "init",
      });
      setTimeout(() => {
        this.setState({ inactiveGame: false });
      }, 167);
    }
  };
  handleChange = () => {
    setTimeout(() => {
      this.Globals.WS.sendMessage(
        MessageFactory.createMessage(Protocol.STEP_ROUND, this.actions.CHANGE)
      );
    }, 167);

    this.setState({
      currentAction: "",
      // gameStates: "change",
      cardChange: true,
    });
  };

  handleStepRound = (b) => {
    this.handleCashout(true);
    this.setState({ currentAction: b, gameStates: "step", cardChange: true });
    switch (b) {
      case "HI":
        setTimeout(() => {
          this.Globals.WS.sendMessage(
            MessageFactory.createMessage(Protocol.STEP_ROUND, this.actions.HI)
          );
        }, 167);
        break;
      case "LO":
        setTimeout(() => {
          this.Globals.WS.sendMessage(
            MessageFactory.createMessage(Protocol.STEP_ROUND, this.actions.LO)
          );
        }, 167);

        break;
      default:
        break;
    }
  };
  handleEndRound = () => {
    const { cashout } = this.state;
    if (!cashout) {
      this.handleNotification(
        "Unable to cashout. Pick the higher or lower selection first"
      );
    } else {
      this.handleNotification(false);
      this.setState({ gameStates: "cashout" });
      setTimeout(() => {
        this.Globals.WS.sendMessage(
          MessageFactory.createMessage(Protocol.END_ROUND)
        );
      }, 167);
    }
  };

  getBetReply = (id) => {
    this.setState({ betReply: null });
    const getRound = MessageFactory.createMessage(Protocol.GET_ROUND, id);
    return this.Globals.WS.sendMessage(getRound);
  };
  handleVolumeLocal = (e) => {
    this.setState({ volumeLocal: e });
  };
  


  render() {
    const {
      balance,
      bet,
      noSignal,
      errorMsg,
      inactiveGame,
      gameIsOn,
      notification,
      notificationfadeOut,
      cashout,
      provablyFairSeeds,
      stateRound,
      myHistory,
      allHistory,
      highRoller,
      picks,
      result,
      above,
      userSettings,
      cardHistory,
      rotateBtnDisable,
      isDisabled,
      userInfo,
      winSound,
      user_id,
      volumeLocal,
      betReply,
      gameStates,
      cardChange,
      pageNotFound,
    } = this.state;
    return (
      <AppContainer className="appcontainer">
        {noSignal ? (
          <NoSignal
            Globals={this.Globals}
            errorMsg={errorMsg}
            userSettings={userSettings}
          />
        ) : (
          <Hilo
            balance={balance}
            gameStates={gameStates}
            winSound={winSound}
            volumeLocal={volumeLocal}
            bet={bet}
            userId={user_id}
            userInfo={userInfo}
            above={above}
            notifyText={notification}
            gameIsOn={gameIsOn}
            inactiveGame={inactiveGame}
            betReply={betReply}
            cashout={cashout}
            isDisabled={isDisabled}
            result={result}
            rotateBtnDisable={rotateBtnDisable}
            picks={picks}
            stateRound={stateRound}
            cardHistory={cardHistory}
            userSettings={userSettings}
            provablyFairSeeds={provablyFairSeeds}
            history={{ myHistory, allHistory, highRoller }}
            Globals={this.Globals}
            cardChange={cardChange}
            saveUserSettings={this.saveUserSettings}
            handleAbove={this.handleAbove}
            handleNotification={this.handleNotification}
            handleBetAmount={this.handleBetAmount}
            handleStartRound={this.handleStartRound}
            handleChange={this.handleChange}
            handleStepRound={this.handleStepRound}
            handleEndRound={this.handleEndRound}
            handleIsDisabled={this.handleIsDisabled}
            notificationfadeOut={notificationfadeOut}
            getBetReply={this.getBetReply}
            handleVolumeLocal={this.handleVolumeLocal}
            pageNotFound={pageNotFound}
          />
        )}
        {notification && (
          <Notification
            notifyText={notification}
            fadeOut={notificationfadeOut}
            handleNotification={this.handleNotification}
            userSettings={userSettings}
          />
        )}
      </AppContainer>
    );
  }
}

export default App;
